import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ViewEncapsulation,
  ViewChild,
  ElementRef
} from '@angular/core';
import {Subject} from 'rxjs';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import {MatCalendar, MatDatepickerInputEvent } from '@angular/material/datepicker';
import {default as _rollupMoment} from 'moment';
import { IDatepickerOption } from '../../../models/IDatepickerOption';
import { FormControl } from '@angular/forms';



//Formats from moment.js
export const MY_FORMATS_KEY = {
  parse: {
    dateInput: 'MM/DD/YYYY',
  },
  display: {
    dateInput: 'MM/DD/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};


@Component({
  selector: 'ff-datepicker-keyboard',
  templateUrl: './datepicker-keyboard.component.html',
  encapsulation: ViewEncapsulation.Emulated,
  styleUrls: ['./datepicker-keyboard.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS_KEY},
  ],
})
export class DatepickerKeyboardComponent implements OnInit {

  ffDatepickerHeaderKeyboard = FFDatepickerHeaderKeyboard;
  @ViewChild('inputKeyboardDatepicker') el:ElementRef;


    /**
     * Options to configure min and max date to datepicker
     * Use the IDatepickerOption interface: { minDate: Date, maxDate: Date }
     * * @internal
    */
     @Input() options?: IDatepickerOption;

     /**
     * Options to enable ordisable the datepicker
     * * @internal
    */
    @Input() isDisabled?: boolean;

    /**
     * Options to enable ordisable the datepicker
     * * @internal
    */
    @Input() placeholder?: string = "MM/DD/YYYY";

     /**
      * Return the selection updated each time the user choses a new date.
      * * @internal
     */
    @Output() selection = new EventEmitter<Date> ();

    //variable date that will be used as the output
    private date: Date;

    @Input() set default(_date: Date) {
      if(!_date) return;

        this.date = _date;
        this.isDateSelected = true;
        this.formDate.setValue(this.date);
        this.selection.emit(this.date);
    }

    minDate : Date = new Date(0);
    maxDate : Date = new Date();

    isDpActive = false;
    isDateSelected = false;


    formDate = new FormControl();

  constructor(
  ) { }

  ngOnInit() {
    setTimeout(() => {
      this.el.nativeElement.value = "";
      this.el.nativeElement.placeholder = this.placeholder;
    });

    if (this.options !== undefined){
      this.minDate = this.options.minDate !== undefined ? this.options.minDate : this.minDate;

      //If there is no input with maxDate parameter, maxDate will be 30 years from the present date
      if (this.options.maxDate !== undefined){
        this.maxDate = this.options.maxDate
      } else {
        this.maxDate.setFullYear(this.maxDate.getFullYear() + 30);
      }
    } else {
      this.maxDate.setFullYear(this.maxDate.getFullYear() + 30);
    }

    this.isDisabled = this.isDisabled !== undefined ? this.isDisabled : false;

  }

  ngOnChanges() {
    if (this.isDisabled){
      this.formDate.disable();
    } else {
      this.formDate.enable();
    }
  }

  //Handles date selection
  chosenDateHandler(event: MatDatepickerInputEvent<Date>) {
    this.date = event.value;

    this.isDateSelected = this.date !== null ? true : false;

    this.selection.emit(this.date);

  }

   //Toggle control for calendar
   onCalendarActive() {
    this.isDpActive = !this.isDpActive;
  }

  // Return true if valid char for current date value with MM/DD/YYYY format
  keyPressDate(event : KeyboardEvent) {

    let value = (event.target as HTMLInputElement).value;
    let key = event.key;

    return /^((\d{0,2})|(\d{1,2}(\/\d{0,2})?)|(\d{1,2}\/\d{1,2}(\/\d{0,4})?))$/.test(value + key);
  }
}



/** Custom header component for datepicker. */
@Component({
  selector: 'ff-datepicker-header-keyboard',
  styles: [`
    .dp-header {
      padding: 0.5em;
      background-color: #c81414;
      color: white;
      height: 4em;
      border-radius: 4px;
    }

    .dp-horizontal {
      width: 80px;
      height: 175px;
    }

    .year-header-label {
      font-weight: 100;
      text-align: center;
      padding: 14px;
      opacity: 0.7;
    }

    .dp-year {
      margin-bottom: -9px;
      margin-top: 3px;
    }

    .month-header-label {
      font-weight: 400;
      text-align: center;
      padding: 14px;
      font-size: 1.2em;
    }

    .selector-container {
      justify-content: space-between;
      background-color: #c81414;
      border-radius: 5px;
    }

    .button-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 96%;
      background-color: white;
      padding: 15px 5px 15px;
    }

    .btn-selector {
      background-color: white;
      color: black;
      width: 10%;
      border-style: none;
      display: flex;
      margin-right: 6%;
    }

    .btn-selector-double-arrow {
      background-color: white;
      color: black;
      width: 10%;
      border-style: none;
      display: flex;
      margin-top: 10px;
    }

    .btn-selector-double-arrow .mat-icon {
      margin: -85%;
    }

    .label-header {
      margin-top: 2px;
      font-size: 14px;
    }

    .btn-selector:hover, .btn-selector-double-arrow:hover {
      transform:scale(1.3,1.3);
    }
  `],
  templateUrl: '../headers/datepicker-header.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FFDatepickerHeaderKeyboard<D> implements OnDestroy {
  private _destroyed = new Subject<void>();

  constructor(
      private _calendar: MatCalendar<D>, private _dateAdapter: DateAdapter<D>) {
  }

  ngOnDestroy() {
    this._destroyed.next();
    this._destroyed.complete();
  }

  //Gets year label to use it in the header
  get yearLabel() {
    return this._dateAdapter
        .format(this._calendar.activeDate, 'YYYY');
  }

  //Gets month label to use it in the header
  get monthLabel() {
    return this._dateAdapter
        .format(this._calendar.activeDate, "MMMM");
  }

  get dateLabel() {
    return this._dateAdapter
        .format(this._calendar.activeDate, "ddd, MMM D");
  }

  previousClicked(mode: 'month' | 'year') {
    this._calendar.activeDate = mode === 'month' ?
        this._dateAdapter.addCalendarMonths(this._calendar.activeDate, -1) :
        this._dateAdapter.addCalendarYears(this._calendar.activeDate, -1);
  }

  nextClicked(mode: 'month' | 'year') {
    this._calendar.activeDate = mode === 'month' ?
        this._dateAdapter.addCalendarMonths(this._calendar.activeDate, 1) :
        this._dateAdapter.addCalendarYears(this._calendar.activeDate, 1);
  }
}

